import type { NodeId } from '@ipfabric/utils';
import { plainSet } from '@ipfabric/utils/fp/plainSet';
import type { GraphState } from 'components/Graph/GraphState';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';

export const selectSelectedVisibleNodeIds: (s: GraphState) => Set<NodeId> =
  createScopedSelector(() =>
    createSelector(
      (s) => s.graph.selectedNodeIds,
      (s) => s.graph.hiddenNodes,
      (selectedNodeIds, hiddenNodeIds) =>
        plainSet.diff(hiddenNodeIds)(selectedNodeIds),
    ),
  );
